import {
  Directive,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[deferLoad]',
})
export class DeferLoadDirective implements AfterViewInit, OnDestroy {
  @Output() public deferLoad: EventEmitter<any> = new EventEmitter();

  public intersectionObserver: IntersectionObserver;

  constructor(private element: ElementRef) {}

  public ngAfterViewInit() {
    if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.checkForIntersection(entries);
      }, {});
      // tslint:disable-next-line: no-angle-bracket-type-assertion
      this.intersectionObserver.observe(<Element>this.element.nativeElement);
    } else {
      this.deferLoad.emit();
    }
  }

  public ngOnDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  private checkForIntersection(entries: Array<IntersectionObserverEntry>) {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (this.checkIfIntersection(entry)) {
        this.deferLoad.emit();
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        this.intersectionObserver.unobserve(<Element>this.element.nativeElement);
        this.intersectionObserver.disconnect();
      }
    });
  }

  private checkIfIntersection(entry: IntersectionObserverEntry) {
    return entry.isIntersecting && entry.target === this.element.nativeElement;
  }
}
